<script>
import WoliLogo from '@/assets/WOLI-LOGO.svg'
export default {
  name: 'Footer',
  components: { WoliLogo },
  props: {
    scale: {
      type: Number,
      default: 1
    },
    height: {
      type: String,
      default: '150px'
    }
  },
  computed: {
    version () {
      // eslint-disable-next-line no-undef
      return VERSION
    },
    styles () {
      return {
        footer: {
          '--scale': this.scale,
          '--height': this.height
        }
      }
    }
  }
}
</script>

<template>
  <div
    class="footer"
    :style="styles.footer"
  >
    <div
      class="endereco"
      v-html="$wl.strings['endereco-contato']"
    />
    <div
      class="logo-container"
      :title="version"
    >
      <WoliLogo
        ref="logo"
        class="logo"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer {
  background-color: var(--surface-light);
  border-color: var(--surface);
  width: 100%;
  height: calc(var(--height) * var(--scale));
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-width: 0;
  border-top-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  .endereco {
    color: var(--on-surface);
    font-size: calc(16px * var(--scale));
    padding: calc(5px * var(--scale));
    margin-left: calc(10% * var(--scale));
  }
  .logo-container {
    margin-right: calc(10% * var(--scale));
    .logo {
      height: calc(40px * var(--scale));
      width: calc(120px * var(--scale));
      .blue{
        fill: #134B8A;
      }
      .red{
        fill: #EE3234;
      }
    }
  }
}
</style>
